module.exports = __webpack_public_path__ + "static/media/ic_round.022d1c99.png";